import React, { useContext } from 'react';
import { Card, CardContent, CardMedia, Typography, Grid } from '@mui/material';
import { SecondaryButton } from '../Button';
import NumberInput from '../NumberInput';
import { CartItemProps } from '../../models/product';
import { ProductContext } from '../../context/products-context';

const CartItem = (props: CartItemProps) => {
  const {
    name,
    price,
    images,
    quantity
  } = props;

  const mainImage = images[0];

  const { removeFromCart, setCartQuantity } = useContext(ProductContext);

  const handleIncrement = (event: React.FocusEvent | React.PointerEvent | React.KeyboardEvent, value: number | null) => {
    setCartQuantity(name, value);
  };

  return (
    <Card sx={{m: 0, boxShadow: 0}}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid size={4}>
            <CardMedia
              component="img"
              alt={name}
              src={mainImage}
              sx={{ 
                borderRadius: '10%',
                width: '100%',
                height: 'auto',
                aspectRatio: '1 / 1', 
                objectFit: 'cover'
              }}
            />
          </Grid>
          <Grid size={5} sx={{px: 1}}>
            <Typography fontSize={14} variant="subtitle1" fontWeight={600}>{name}</Typography>
            <Typography fontSize={14} variant="subtitle1">R{price}</Typography>
          </Grid>
          <Grid size={3} display={'flex'} flexDirection={'column'} justifyContent={'space-between'} pt={1}>
            <NumberInput
              value={quantity}
              onChange={handleIncrement}
              min={1} 
              max={100}
            />
            <SecondaryButton
              onClick={() => removeFromCart(name, quantity)}
              sx={{
                fontSize: 10,
                py: 0.5,
                px: 1,
                minWidth: 0,
              }}
            >
              Remove
            </SecondaryButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CartItem;